/**
 * Markdown — the one shared way to render agent-authored markdown as HTML.
 *
 * Wraps `renderMarkdown` (DOMPurify-sanitized, strict allow-list: no img, no
 * class, no inline style) in a `.md-body` div so surfaces can scope their own
 * typography (e.g. `.wk-read .md-body { … }`). Use `stripMarkdownInline` from
 * lib/markdown for clamped one-line contexts instead of rendering blocks.
 */
import { useMemo, type CSSProperties } from "react";
import { markdownHtml } from "../lib/markdown.js";

export function Markdown({
  text,
  className,
  style,
}: {
  text: string;
  className?: string;
  style?: CSSProperties;
}) {
  const props = useMemo(() => markdownHtml(text), [text]);
  return (
    <div
      className={"md-body" + (className ? " " + className : "")}
      style={style}
      {...props}
    />
  );
}
